import { IWbHttpOptions, WbSessionActions } from '@interco/inter-webview-bridge'

enum CustomActions {
  GET_SUPER_APP_TYPE = 'getSuperAppType',
  DOWNLOAD_TERM = 'downloadTerm',
  NAVIGATE_HOME = 'navigateHome',
  NAVIGATE_TO_HOME = 'navigateToHome',
  OPEN_NATIVE_BROWSER = 'openNativeBrowser',
}

export const Actions = {
  ...WbSessionActions,
  ...CustomActions,
}

type CommonArguments = {
  endpoint: string
  headers?: Record<string, string>
  options?: IWbHttpOptions
}

type GetOrDelete = CommonArguments & {
  method: 'GET' | 'DELETE'
}

export type PostOrPut = CommonArguments & {
  method: 'POST' | 'PUT'
  body?: Record<string, unknown>
}

export type Request = GetOrDelete | PostOrPut

export enum DeepLinks {
  NATURA = 'bancointer://intershop/afiliados/loja/natura',
  HOME = 'bancointer://login',
  CREDIARIO_DIGITAL = 'bancointer://intershop',
  CREDIARIO_DIGITAL_PHASES = 'bancointer://intershop/home/digital_booklet',
  CARTAO_CREDITO = 'bancointer://cartoes',
  PIX = 'bancointer://pix/cadastroChave',
  SECURITY = 'bancointer://seguroVidaV2',
  SAVINGS = 'bancointer://meiosPagamento/rota/POUPANCA_MAIS_LIMITE_ONBOARDING',
  SALARY = 'bancointer://portSalario',
  // DOUTOR_INTER = 'bancointer://meiosPagamento/rota/FRIENDLY_NEGOTIATION',
}
export type SuperAppType = {
  superAppType: AppType
}

export type AppInfo = {
  version?: string
  theme?: string
  tema?: string
  deviceName?: string
  deviceType?: string
  nomeAparelho?: string
  versao?: string
  nomeTipo?: string
}

export type UserInfo = {
  account: string
  addressComplement: string
  addressName: string
  addressNumber: string
  birthDate: string
  cellPhoneNumber: string
  cep: string
  city: string
  cpf: string
  email: string
  name: string
  neighborhood: string
  phoneNumber: string
  state: string
  segmentation?: string
}
